<template>
    <div id="app">
        <div id="top">
            本网站为个人学习分享 仅供个人用途 <br>
            {{time}}
        </div>
        <div id="main">
            <div id="show">
                <img :src="pic">
                <el-switch
                        style="margin: 20px"
                        @change="change"
                        v-model="value"
                        active-text="打开"
                        inactive-text="关闭">
                </el-switch>
            </div>

        </div>
        <div id="bottom">
            <a href="http://beian.miit.gov.cn ">皖ICP备17028604号-3</a>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                value: false,
                pic: require('./assets/off.png'),
                time: ''
            }
        },
        mounted() {
            setInterval(() => {
                this.time = new Date().toLocaleString();
            }, 1000)
        },
        methods: {
            change(e) {
                if (e) {
                    this.pic = require('./assets/on.png')
                } else {
                    this.pic = require('./assets/off.png')
                }
            }
        }
    }
</script>

<style>
    body {
        margin: 0;
        padding: 0;
    }

    #app {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100vh;
        background: url("assets/pic.jpg") no-repeat;
        background-size: 100%;
    }

    #top {
        text-align: center;
        color: white;
    }

    #main {
        width: 100%;
        height: 80vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #show {
        width: 60%;
        height: 60%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: rgba(80, 211, 255, 0.32);
    }

    #bottom {
        width: 100%;
        text-align: center;
    }

    #bottom a {
        color: red;
        text-decoration: none;
    }

    #bottom a:hover {
        font-size: 20px;
        font-weight: 900;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue